import { FlashMessageGenerateTokenDto } from "../../../dto/flashmessagegenereratetoken/flashmessagegeneratetoken";
import { APIResponse, APIResponseDtoImpl } from "../../apiresponse";

export interface RewardPointGenerateTokenResponse extends APIResponse
{
    getRewardPointGenerateTokenResponseDto(): FlashMessageGenerateTokenDto;
}

export class RewardPointGenerateTokenResponseDtoImpl extends APIResponseDtoImpl implements RewardPointGenerateTokenResponse
{
    private flashMessageGenerateTokenDto : FlashMessageGenerateTokenDto;

    getRewardPointGenerateTokenResponseDto(): FlashMessageGenerateTokenDto
    {
        return this.flashMessageGenerateTokenDto;
    }

    setRewardPointGenerateTokenResponseDto(flashMessageGenerateTokenDto: FlashMessageGenerateTokenDto)
    {
        this.flashMessageGenerateTokenDto = flashMessageGenerateTokenDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/rewardpoint/rewardpointgeneratetoken/rewardpointgeneratetokenresponse.tsx